import RowActions from './RowActions';

const UserActions = ({
  user,
  isBusy,
  onViewProfile,
  onToggleEnabled,
  onArchive,
}) => {
  const isSuperAdmin = Boolean(user?.isSuperAdmin);
  const isArchived = Boolean(user?.archived);
  const isEnabled = user?.enabled !== false;

  return (
    <div className="sa-table-action-group">
      <button
        type="button"
        className="sa-tertiary-button"
        onClick={() => onViewProfile?.(user)}
        disabled={isBusy}
      >
        View
      </button>

      <RowActions label={user?.name || user?.email || 'user'} actions={[
        { label: isEnabled ? 'Disable' : 'Enable', disabled: isBusy || isSuperAdmin || isArchived, onSelect: () => onToggleEnabled?.(user, !isEnabled) },
        { label: 'Archive', danger: true, disabled: isBusy || isSuperAdmin || isArchived, onSelect: () => onArchive?.(user) },
      ]} />
    </div>
  );
};

export default UserActions;
